import React from "react";
import "./RegistrationOptionsPage.scss";
import { useHistory } from "react-router-dom";
import { Content, usePathFactory, useTranslator } from "@sia/style-guide";
import Page from "../../../Page";

import OptionTiles from "./OptionTiles";

const RegisterationOptionsPage = () => {
  const translate = useTranslator();
  const pathFactory = usePathFactory();
  const history = useHistory();
  const options = [
    {
      title: translate("wizard.sia-ways.master.title"),
      description: translate("wizard.sia-ways.master.points"),
      onClick: () => history.push(pathFactory.create("wizard/registration-info/master")),
    },
    {
      title: translate("wizard.sia-ways.bachelor.title"),
      description: translate("wizard.sia-ways.bachelor.points"),
      onClick: () => history.push(pathFactory.create("wizard/registration-info/bachelor")),
    },
    {
      title: translate("wizard.sia-ways.htl.title"),
      description: translate("wizard.sia-ways.htl.points"),
      onClick: () => history.push(pathFactory.create("wizard/registration-info/htl")),
    },
    {
      title: translate("wizard.sia-ways.no-diploma.title"),
      description: null,
      onClick: () => history.push(pathFactory.create("wizard/registration-info/no-diploma")),
    },
  ];
  return (
    <Page>
      <Content centeredTexts={true}>
        <div className="registration-options">
          <h1 className="productive-heading-04 sia-text-12">{translate("wizard.sia-ways.title")}</h1>
          <p className="registration-options__info sia-margin-02-bottom">{translate("wizard.sia-ways.info")}</p>
          <OptionTiles options={options} />
        </div>
      </Content>
    </Page>
  );
};

export default RegisterationOptionsPage;
